import { AxiosResponse } from "axios";
import { axiosInterceptor } from "./request-interceptor";

export async function signIn(email: string, password: string): Promise<AxiosResponse<any>> {
    return axiosInterceptor.post("/auth/login", { sys_user: { email, password } });
}

export async function signOut(): Promise<AxiosResponse<any>> {
    return axiosInterceptor.delete("/auth/logout");
}

// export async function isSessionAlive(): Promise<AxiosResponse<SysUser>> {
//     return axiosInterceptor.get("/auth/session_alive");
// }

export const isSessionAlive = async () => {
    try {
        return await axiosInterceptor.get("/auth/session_alive");
    } catch (error: any) {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
            return null;
        }
        throw error;
    }
};


export async function httpRequestByUrl(url: string): Promise<AxiosResponse<any>> {
    return axiosInterceptor.get(url);
}